import * as Yup from 'yup';
// import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useMemo, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, FormikProvider, useFormik } from 'formik';
// material
import { LoadingButton, MobileDatePicker } from '@material-ui/lab';
import { useTheme } from '@material-ui/core/styles';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { InputLabel } from '@mui/material';

import {
  Box,
  Card,
  Grid,
  Stack,
  Switch,
  TextField,
  Typography,
  Link,
  FormHelperText,
  FormControlLabel,
  Button,
  Container,
  Autocomplete,
  Chip,
  CardHeader,
  InputAdornment,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Paper
} from '@material-ui/core';

// utils
import { fData } from '../../../utils/formatNumber';
import fakeRequest from '../../../utils/fakeRequest';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';
import Page from 'src/components/Page.js';
//
import Label from '../../Label';
import { UploadAvatar, UploadSingleFile } from '../../upload';
import { Link as RouterLink } from 'react-router-dom';
import countries from '../user/countries';
import moment from 'moment';
import axios from 'axios';
import { currentFacilityId, filteredOtherFacilityTypes, REST_API_END_POINT, UNITS ,FacilityTypes} from '../../../constants/Defaultvalues';
import AddTimeAndMaterialProduct from './AddTimeAndMaterialProduct';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import { supabase } from '../../../supabase/supabaseClient';
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import editFill from '@iconify/icons-eva/edit-fill';
import Modal from '../../_dashboard/blog/ProjectModel';
import JobCost from '../../../pages/dashboard/receipe';
import AddNewProductionWorkFlow from '../../../pages/dashboard/AddNewProductionWorkFlow';

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;
      
      // Determine chunk type with priority: hash < otherSpecial < digit < letter
      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3; // letter
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Same type, compare values
    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

const splitOrderCatalogTypes = [
  { id: 'all', label: 'All', inhouse: null, isTrafficCatalog: null },
  { id: 'in_stock', label: 'In Stock', inhouse: 4, isTrafficCatalog: false },
  {
    id: 'client_owned',
    label: 'Client Owned',
    inhouse: 5,
    isTrafficCatalog: false,
  },
  { id: 'traffic', label: 'Traffic', inhouse: 1, isTrafficCatalog: true },
  {
    id: 'production_catalog',
    label: 'Production Catalog',
    inhouse: 1,
    isTrafficCatalog: false,
  },
  // {
  //   id: 'split_catalog',
  //   label: 'Split Catalog',
  //   inhouse: 6,
  //   isTrafficCatalog: false,
  // },
  {
    id: 'estimate_catalog',
    label: 'Estimate Catalog',
    inhouse: 7,
    isTrafficCatalog: false,
  },
]

export default function AddProject({ fromSplitEstimate, onClose,productName,RecipeId,splitPercentageFromEstimate,selectedRecipeId,targetFacilityId, modalInhouse, modalIsTrafficCatalog, modalSelectedTab, modalTimeAndMaterial, fromRecipeList, selectedProductForCatalog = null,allProducts,isFromEstimateJob ,currentCatalogId = null, estimateRequestId = null}) {
  const location = useLocation()
  const listPage = location.state?.listPage ?? 0;
  const rowsPerPage = location.state?.rowsPerPage ?? 25;
  // Use modal props if provided (for modal usage), otherwise use router location state
  // This ensures backward compatibility - existing code without modal props continues to work
  const in_house=fromSplitEstimate ? 6 : (modalInhouse !== undefined ? modalInhouse : location.state?.inhouse)
  console.log('in_house------', in_house)
  console.log('selectedProductForCatalog------', selectedProductForCatalog)
  const timeAndMaterial=modalTimeAndMaterial !== undefined ? modalTimeAndMaterial : location.state?.timeAndMaterial
  const isTrafficCatalog = modalIsTrafficCatalog !== undefined ? modalIsTrafficCatalog : location.state?.isTrafficCatalog
  const selectedTab = fromSplitEstimate ? 'split_catalog' : (modalSelectedTab !== undefined ? modalSelectedTab : location.state?.selectedTab)

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme()

  // Browser back-button auto-save handling (minimal & non-invasive)
  const formikRef = useRef(null);
  const allowBrowserBackRef = useRef(false);
  const autoSaveThenGoBackRef = useRef(false);
  const backConfirmInProgressRef = useRef(false);
  const [openBackConfirmDialog, setOpenBackConfirmDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const [selectedThumbnail, setSelectedThumbnail] = useState(null);
  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [tags, setTags] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [workflows, setWorkflows] = useState([])
  const [recipe, setRecipe] = useState([])
  const [inHouse, setInHouse] = useState(in_house)
  const [timeMaterial,setTimeMaterial] = useState(timeAndMaterial)
  const currentDate = moment().format('MM-DD-YYYY');
  const [avaTaxCategory, setAvaTaxCategory] = useState([])
  const [otherInstallationSplitInstallLabour, setOtherInstallationSplitInstallLabour] = useState([])
  const [currentInstallationSplitManagementSettings, setCurrentInstallationSplitManagementSettings] = useState([])
  const [splitPercentage, setSplitPercentage] = useState(splitPercentageFromEstimate || 0)
  const [openRecipeModal, setOpenRecipeModal] = useState(false);
  const [openWorkflowModal, setOpenWorkflowModal] = useState(false);
  const [isCombiningWorkflow, setIsCombiningWorkflow] = useState(false);
  const [selectedCatalogType, setSelectedCatalogType] = useState('all'); // Default to 'all'
  const [isRecipeLoading, setIsRecipeLoading] = useState(false)
  const [vendors, setVendors] = useState([])
  // const isEdit =false
  const NewProductSchema = Yup.object().shape({
    name: Yup.string().required('Name is required')
    .matches(/^[^\t\n\r:]+$/, 'Name cannot contain colons(:)'),
    // .matches(/^[a-zA-Z0-9\s\-]+$/, 'Name can only contain letters, numbers, spaces, and hyphens')
    
    //  vpt_number:Yup.number().required('Part number is required'),
    //  vpt_number:Yup.string().required('SKU is required'),
    // price:inHouse && Yup.number().typeError('Please enter a valid price').required('Wholesale Price is required'),
    // price:inHouse && Yup.number().typeError('Please enter a valid price'),
    retail_price:(inHouse || isTrafficCatalog) && selectedTab != 'sub_contract' && 
      Yup.number()
        .typeError('Please enter a valid price')
        .required('Retail Price is required')
        .test(
          'min-retail-price',
          'Actual Retail Price cannot be less than Product Cost (Retail)',
          function (retailPrice) {
            const { formula_cost, s_price, markupPrice } = this.parent;
            let productCostRetail;

            if (fromSplitEstimate || inHouse === 6) {
              productCostRetail = formula_cost ? Number(formula_cost) : 0;
            } else {
              const materialCost = typeof s_price === 'number' ? s_price : 0;
              const serviceCost = typeof markupPrice === 'number' ? markupPrice : 0;
              productCostRetail = materialCost + serviceCost;
            }
            
            // Ensure productCostRetail is a number for comparison
            productCostRetail = parseFloat(productCostRetail) || 0;

            // Helper to avoid floating point precision issues and always compare at 2 decimals
            const roundToTwo = (value) =>
              Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;

            if (retailPrice === undefined || retailPrice === null || retailPrice === '') {
              return true; // Allow if retailPrice is not set yet
            }

            const roundedRetailPrice = roundToTwo(retailPrice);
            const roundedProductCost = roundToTwo(productCostRetail);

            return roundedRetailPrice >= roundedProductCost;
          }
        ),
    install_cost:(inHouse || isTrafficCatalog) && selectedTab != 'sub_contract' && 
      Yup.number()
        .typeError('Please enter a valid price')
        .required('Install Price is required')
        .test(
          'min-install-price',
          'Actual Install Price cannot be less than Install Labor Cost',
          function (installCost) {
            const { recipe, fromSplitEstimate, inHouse } = this.parent;
            let installLaborCost = 0;

            if (recipe?.services && Array.isArray(recipe.services)) {
              const installLaborService = recipe.services.find(service => service.service_id == 10);
              if (installLaborService && installLaborService.quantity) {
                if (fromSplitEstimate || inHouse == 6) {
                  installLaborCost = recipe?.expected_install_labor_cost || 0;
                } else {
                  installLaborCost = recipe?.install_labour_cost_with_markup || 0;
                }
              }
            }

            // Ensure installLaborCost is a number for comparison
            installLaborCost = parseFloat(installLaborCost) || 0;

            if (installCost === undefined || installCost === null || installCost === '') {
              return true; // Allow if installCost is not set yet
            }

            return parseFloat(installCost) >= installLaborCost;
          }
        ),
    description: Yup.string().required('Description is required'),
    category: Yup.object().nullable().required('Category is required'),
    unit: Yup.object().nullable(), //.required('Unit is required')
    sub_category: Yup.object().nullable().required('Sub Category is required'),
    workflows: Yup.object().nullable().required('Workflows is required'),
    recipe: (inHouse || isTrafficCatalog || selectedTab === 'split_catalog')&&Yup.object().nullable().required('Product Formula is required'),
    formula_cost: (inHouse || isTrafficCatalog || selectedTab === 'split_catalog') && Yup.number().required('formula cost is required'),
    markup: (!inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog') && Yup.number().required('Markup is required').nullable(),
    sub_contract_price: (!inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog') && Yup.number().required('Price is required').nullable(),
    vendor: (!inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog')
      ? Yup.string().required('Vendor is required').nullable()
      : Yup.string().nullable(),
    facility_id: (inHouse == 6 || selectedTab == 'split_catalog' || fromSplitEstimate) ? Yup.object().nullable().required('Facility Type is required') : Yup.object().nullable(),
    lead_time: Yup.number().typeError('Please enter a valid number').nullable(),
    // in_stock_no: Yup.string()
    //   .when([], {
    //     is: () => inHouse === 4,
    //     then: Yup.string().required('Stock is required for Stock Catalogs'),
    //     otherwise: Yup.string().nullable(),
    //   }),
    // start: Yup.date(),
    // end: Yup.date(),
    // avatarUrl: Yup.mixed().required('Product image is required'),
  });
  //

  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1)
  }));
  //
  const fetchAllProductCategory = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const userType = user.user_type
      const userId = user.user_id
      axios
        .post(REST_API_END_POINT + 'product/get-all-product-categories',{userType,userId,isVendor:1})
        .then((res) => {
          let data = res.data
          if (data.status === 1) {
            const allCategories = data?.productCategories?.filter((item) => item?.category_type == 1)
            const activeCategories = allCategories?.filter((item) => item.status == 1)
            // Sort alphanumerically by name
            const sortedCategories = [...activeCategories].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
            setCategory(sortedCategories)
            setVendors(data?.vendorData?.data || [])
          }
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    } catch (e) {
      console.error('Exception:', e)
    }
  }
  const fetchAllRecipe = async () => {
    try {
      setIsRecipeLoading(true)
      axios
        .post(REST_API_END_POINT + 'product/get-all-recipes')
        .then((res) => {
          let data = res.data
          if (data.status === 1) {
            const filteredData =  data.recipes.filter((recipe) =>isTrafficCatalog ? recipe?.type === 2 : (fromSplitEstimate || inHouse == 6) ? recipe?.type === 3 : recipe?.type === 1) || data.recipes
            // Sort alphanumerically by name
            const sortedData = [...filteredData].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
            setRecipe(sortedData)
            // Store otherInstallationSplitInstallLabour data
            if (data?.otherInstallationSplitInstallLabour) {
              setOtherInstallationSplitInstallLabour(data?.otherInstallationSplitInstallLabour)
            }
            // Store currentInstallationSplitManagementSettings data
            if (data?.currentFacilitySplitManagementSettings) {
              setCurrentInstallationSplitManagementSettings(data?.currentFacilitySplitManagementSettings)
            }
          }
          setIsRecipeLoading(false)
        })
        .catch((error) => {
          console.error('Error:', error)
          setIsRecipeLoading(false)
        })
    } catch (e) {
      console.error('Exception:', e)
      setIsRecipeLoading(false)
    }
  }
  const getAllWorkflows = async () => {
    try {
      axios.post(`${REST_API_END_POINT}onboard/get-all-workflows-products`)
        .then((res) => {
          // Sort alphanumerically by name
          const sortedWorkflows = [...(res.data.result || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
          setWorkflows(sortedWorkflows)
        })
        .catch((error) => {
          console.log(error)
        })
    } catch (error) {
      console.log(error)
    }
  }
  const fetchAllAvalaraTaxCategories = async()=>{
    try {
       const response = await axios.post(`${REST_API_END_POINT}avalara/get-all-tax-category`);
       console.log("fetchAllAvalaraTaxCategories",response?.data?.result)
       // Sort alphanumerically by description
       const sortedCategories = [...(response?.data?.result || [])].sort((a, b) => alphanumericCompare(a?.description || '', b?.description || ''))
       setAvaTaxCategory(sortedCategories)
    } catch (error) {
      console.error('Error fetching Avalara tax categories:', error);
      
    }
  }

  const uploadThumbnailToSupabase = async (file) => {
    try {
      const timestamp = Date.now();
      const sanitizedFileName = file.name.replace(/\s+/g, '_');
      const fileName = `${timestamp}_${sanitizedFileName}`;
      const filePath = `product-thumbnails/${fileName}`;

      const { error: uploadError } = await supabase.storage
        .from('signwise-attachments')
        .upload(filePath, file);

      if (uploadError) throw uploadError;

      const {
        data: publicUrlData,
        error: urlError,
      } = supabase.storage
        .from('signwise-attachments')
        .getPublicUrl(filePath);

      if (urlError || !publicUrlData?.publicUrl) {
        throw new Error('Failed to generate public URL');
      }

      return publicUrlData.publicUrl;
    } catch (error) {
      console.error('Error uploading thumbnail to Supabase:', error);
      throw error;
    }
  };
  useEffect(() => {
    fetchAllProductCategory()
    getAllWorkflows()
    fetchAllRecipe()
    fetchAllAvalaraTaxCategories()
  }, [])

  const filteredProductOptions = useMemo(() => {
    return (allProducts || []).filter((option) => {
      if (selectedCatalogType === 'all') {
        return true;
      }
  
      // Filter based on the selected catalog type
      switch (selectedCatalogType) {
        case 'in_stock':
          return option.inhouse === 4;  // In Stock
        case 'client_owned':
          return option.inhouse === 5;  // Client Owned
        case 'traffic':
          return option.isTrafficCatalog == 1;  // Traffic
        case 'production_catalog':
          return option.inhouse === 1 && option.isTrafficCatalog !== 1 ;  // Production Catalog
        case 'estimate_catalog':
          return option.inhouse === 7;  // Estimate Catalog
        case 'split_catalog':
          return option.inhouse === 6;  // Split Catalog
        default:
          return false;  // If no match, don't show the product
      }
    }).sort((a, b) => {
      const getSortKey = (option) => {
        const name = (option.name || '').trim();
        return name;
      };
  
      const keyA = getSortKey(a);
      const keyB = getSortKey(b);
  
      // Strict alphanumeric sort: case-insensitive with natural numeric ordering
      return keyA.localeCompare(keyB, undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    });
  }, [allProducts, selectedCatalogType, selectedTab]);  // Re-run filter when `allProducts` or `selectedCatalogType` changes
  
  

  const initialUnit = UNITS?.find((data) => data.id === 4);

  const currentFacility = FacilityTypes.find(facility => facility.id === currentFacilityId);
  const currentFacilityCode = currentFacility ? currentFacility.code : ''; 
  console.log("currentFacilityCode",currentFacilityCode);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: (fromSplitEstimate || selectedProductForCatalog) ? productName : '',
      vpt_number: '',
      ul_number: '',
      price: '',
      retail_price: selectedProductForCatalog ? (selectedProductForCatalog?.actual_retail_price ?? selectedProductForCatalog?.adjustedGroupRetailEach ?? '') : '',
      install_cost: selectedProductForCatalog ? (selectedProductForCatalog?.install_cost ?? selectedProductForCatalog?.adjustedGroupInstallRetailEach ?? '') : '',
      formula_cost: '',
      s_price: '',
      markupPrice: '',
      description: selectedProductForCatalog ? (selectedProductForCatalog?.product_desc || selectedProductForCatalog?.description || '') : ((selectedProductForCatalog && selectedProductForCatalog?.product_desc) ? selectedProductForCatalog?.product_desc : ''),
      start: null,
      end: null,
      avatarUrl: null,
      thumbnail: null,
      category: null,
      unit: initialUnit || null,
      unit_qty:1,
      sub_category: null,
      workflows: selectedProductForCatalog ? workflows.find((workflow) => workflow?.id === selectedProductForCatalog.workflow) ?? null : null,
      recipe: selectedProductForCatalog ? recipe.find((recipe) => recipe?.id === selectedProductForCatalog.recipe_id) ?? null : null,
      pf_retail_markup:null,
      isTrafficCatalog:isTrafficCatalog,
      markup :null,
      sub_contract_price: null,
      in_stock_no: '',
      taxCodeId:null,
      taxCode:'',
      facility_id: null,
      install_labour_quantity: 0,
      expected_cost: 0,
      lead_time: '',
      bin_location: '',
      vendor: '',
      newProductId: selectedProductForCatalog
        ? (selectedProductForCatalog?.product_id || selectedProductForCatalog?.id || null)
        : (currentCatalogId || null)
    },
    validationSchema: NewProductSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors, setFieldError }) => {
      try {
        const shouldGoBackAfterSave = autoSaveThenGoBackRef.current;
        const user = localStorage.getItem('user')
        const userData = JSON.parse(user)
        if ((values?.unit?.id) && (values?.unit?.id !== 4) && (values?.unit_qty == '')) {
          setFieldError('unit_qty', `Please enter the number of ${values?.unit?.name}`)
        } else {
          values.id = userData.user_id
          values.tags = tags?.join(',')
          if (values.start) {
            values.start = moment(values.start).valueOf() / 1000;

            if (isNaN(values.start)) {
              values.start = '';
            }
          }
          else {
            values.start = '';
          }
          if (values.end) {
            values.end = moment(values.end).valueOf() / 1000;

            if (isNaN(values.end)) {
              values.end = '';
            }
          }
          else {
            values.end = '';
          }
          console.log("############Vaaaaaaaaaa", values.recipe);
          
          // Upload thumbnail to Supabase if selected
          let thumbnail = 'default.jpg'; // Default thumbnail when none is selected
          if (selectedThumbnail) {
            try {
              thumbnail = await uploadThumbnailToSupabase(selectedThumbnail);
            } catch (error) {
              enqueueSnackbar('Failed to upload thumbnail', { variant: 'error' });
              setSubmitting(false);
              return;
            }
          }
          
          const formData = new FormData();
          // let retailPrice = (inHouse === 6 || selectedTab === 'split_catalog') ? values.formula_cost : values.retail_price;
          formData.append("added_by", values.id);
          formData.append("thumbnail", thumbnail);
          formData.append("name", values.name);
          // formData.append("vpt_number", values.vpt_number);

          formData.append("ul_number", values.ul_number);
          const formattedDescription = (values.description || '').replace(/\r?\n/g, '\n');
          formData.append("description", formattedDescription);
          formData.append("price", values.price);
          formData.append("retail_price", values.retail_price);
          // formData.append("retail_price", retailPrice);
          formData.append("install_cost", values.install_cost);
          formData.append("formula_cost", values.formula_cost);
          // formData.append("s_price", values.recipe?.expected_cost);
          formData.append("s_price", values.recipe?.expected_material_cost_with_markup || 0);
          
          formData.append("start", values.start);
          formData.append("unit", values.unit.id);
          formData.append("unit_qty", values.unit_qty);
          formData.append("end", values.end);
          formData.append("tags", values.tags);
          formData.append("category", values.category.id);
          formData.append("sub_category", values.sub_category.id);
          formData.append("workflow", values.workflows?.id);
          formData.append("recipe", values.recipe?.id);
          formData.append("pf_cost_without_markup", values.recipe?.expected_cost || 0);
          formData.append("inHouse", inHouse);
          formData.append("pf_retail_markup", values.pf_retail_markup);
          formData.append("isTrafficCatalog", values.isTrafficCatalog);
          formData.append("markup", values.markup);
          formData.append("sub_contract_price", values.sub_contract_price);
          formData.append("in_stock_no", values.in_stock_no);
          formData.append("taxCodeId", values.taxCodeId);
          formData.append("taxCode", values.taxCode);
          formData.append("facility_id", values.facility_id?.id || '');
          formData.append("install_labour_quantity", values?.install_labour_quantity || 0);
          formData.append("expected_cost", values?.expected_cost || 0);
          formData.append("lead_time", values.lead_time);
          formData.append("bin_location", values.bin_location || '');
          if (values.vendor) {
            formData.append("vendor", values.vendor);
          }
          formData.append("facility_code", String(currentFacilityCode));  // Adding facility code dynamically
          formData.append("productIds", String(selectedProductForCatalog?.productIds ?? null ));  
          formData.append("groupId", String(selectedProductForCatalog?.groupId ?? null ));  
          formData.append("requestId", String(estimateRequestId ?? selectedProductForCatalog?.requestId ?? null ));  
          formData.append("isFromEstimateJob", String(!!isFromEstimateJob));

          formData.append("is_existing_catalog", selectedProductForCatalog?.addExistingEstimateCatalog ?? false);
          // Log the key/value pairs
          // console.log("Form data : ");
          // for (var pair of formData.entries()) {
          //   console.log(pair[0] + ' - ' + pair[1]);
          // }
          let addedProductId = null;
          let addedProductData = null;
          try {
            const response = await axios.post(`${REST_API_END_POINT}product/add-product`, formData, {
              headers: { 'Content-Type': 'multipart/form-data' }
            });
            // console.log("response.data : ", response.data);
            if (response.data.status === 1) {
              enqueueSnackbar(`Catalog ${values.name} added successfully`, { variant: 'success' });
              addedProductId = response?.data?.product_id || null;
              addedProductData = response?.data?.product || null;
              // Only for EditEstimateJob (isFromEstimateJob): add-product payload omits recipe
              // formula fields used by "Product formula cost Each". Other AddProducts callers
              // ignore the onClose third arg / do not use this enrichment.
              if (isFromEstimateJob && addedProductData && values.recipe) {
                addedProductData = {
                  ...addedProductData,
                  expected_material_cost_with_markup:
                    values.recipe?.expected_material_cost_with_markup,
                  expected_service_cost_with_markup:
                    values.recipe?.expected_service_cost_with_markup,
                  expected_install_labor_cost_with_markup:
                    values.recipe?.expected_install_labor_cost_with_markup ??
                    values.recipe?.install_labour_cost_with_markup,
                }
              }
              // Update product_added status if this is from split estimate
              if (fromSplitEstimate && selectedRecipeId) {
                const product_id = response?.data?.product_id || null
                try {
                  await axios.post(`${REST_API_END_POINT}split-estimate/update-product-added-status`, {
                    selectedRecipeId: selectedRecipeId,
                    targetFacilityId: targetFacilityId,
                    product_id : product_id
                  });
                } catch (error) {
                  console.error('Error updating product added status:', error);
                }
              }
            }
            else if (response.data.status === 2) {
              enqueueSnackbar('The Catalog already exist!', { variant: 'error' });
            }
            else if (response.data.status === 0) {
              enqueueSnackbar('Failed to add the Catalog', { variant: 'error' });
            }
            else if (response.data.status === 406) {
              enqueueSnackbar(response.data.status, { variant: 'error' });
            }
            else if (response.data.status === 500) {
              enqueueSnackbar('Server error', { variant: 'error' });
            }
          } catch (error) {
            enqueueSnackbar('Error in adding Catalog', { variant: 'error' });
            console.error("Axios request failed:", error.message);
            if (error.response) {
              console.error("Response data:", error.response.data);
              console.error("Response status:", error.response.status);
              console.error("Response headers:", error.response.headers);
            } else if (error.request) {
              console.error("No response received. Request details:", error.request);
            } else {
              console.error("Error setting up the request:", error.message);
            }
          }
          resetForm();
          setSubmitting(false);
          
          // If browser back initiated the submit, go back only after a successful save.
          if (shouldGoBackAfterSave) {
            allowBrowserBackRef.current = true;
            setTimeout(() => {
              window.history.back();
            }, 0);
            return;
          }
          
          if ((fromSplitEstimate || fromRecipeList) && onClose) {
            if(fromSplitEstimate){
              onClose(addedProductId);
            }else{
              onClose(addedProductId, false, addedProductData);
            }
          } else {
            // navigate(PATH_DASHBOARD.products.main,{state:{
            //   in_house:inHouse?'in_house':'sub_contract'
            // }});
            navigate(PATH_DASHBOARD.products.main,{state:{
              in_house:isTrafficCatalog ? 1 : selectedTab === 'in_stock_catalog' ? 4 : selectedTab === 'client_owned_catalog' ? 5 : selectedTab === 'split_catalog' ? 6 : selectedTab === 'estimate_catalog' ? 7 : inHouse ? true : false,listPage: listPage,rowsPerPage: rowsPerPage
        
            }});
          }
        }
      } catch (error) {
        console.error("Error : ", error);
        setSubmitting(false);
        setErrors(error);
      }
      finally {
        autoSaveThenGoBackRef.current = false;
      }
    }
  });

  const { errors, values, touched, handleSubmit,handleChange, isSubmitting, setFieldValue, getFieldProps } = formik;

  // Keep latest formik instance for popstate handler without re-registering listeners
  useEffect(() => {
    formikRef.current = formik;
  }, [formik]);

  const restoreBackGuardEntry = useCallback(() => {
    const st = window.history.state || {};
    window.history.pushState(
      { ...st, __add_products_back_guard: true },
      '',
      window.location.href,
    );
  }, []);

  // Close dialog + stay on page
  const handleBackConfirmClose = useCallback(() => {
    setOpenBackConfirmDialog(false);
    restoreBackGuardEntry();
    backConfirmInProgressRef.current = false;
  }, [restoreBackGuardEntry]);

  // No = go back normally (no auto-save)
  const handleBackConfirmNo = useCallback(() => {
    setOpenBackConfirmDialog(false);
    autoSaveThenGoBackRef.current = false;
    allowBrowserBackRef.current = true;
    setTimeout(() => {
      window.history.back();
    }, 0);
    backConfirmInProgressRef.current = false;
  }, []);

  // Yes = auto-save then go back (after success)
  const handleBackConfirmYes = useCallback(async () => {
    setOpenBackConfirmDialog(false);
    autoSaveThenGoBackRef.current = true;
    try {
      await formikRef.current?.submitForm?.();
    } finally {
      if (autoSaveThenGoBackRef.current) autoSaveThenGoBackRef.current = false;
      if (!allowBrowserBackRef.current) restoreBackGuardEntry();
      backConfirmInProgressRef.current = false;
    }
  }, [restoreBackGuardEntry]);

  // Intercept browser back button: confirm -> auto-save -> go back on success
  useEffect(() => {
    const currentState = window.history.state || {};
    if (!currentState?.__add_products_back_guard) {
      window.history.pushState(
        { ...currentState, __add_products_back_guard: true },
        '',
        window.location.href,
      );
    }

    const handlePopState = () => {
      if (allowBrowserBackRef.current) return;
      if (backConfirmInProgressRef.current) return;
      backConfirmInProgressRef.current = true;
      setOpenBackConfirmDialog(true);
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  // Pre-select recipe and facility when fromSplitEstimate or fromRecipeList and IDs are provided
  useEffect(() => {
    if ((fromSplitEstimate || fromRecipeList) && RecipeId && recipe.length > 0) {
      const selectedRecipe = recipe.find(r => r.id === RecipeId);
      if (selectedRecipe) {
        setFieldValue('recipe', selectedRecipe);
        if(selectedRecipe?.workflow_id){
          let defaultWorkflow = workflows?.find(val => val.id == selectedRecipe?.workflow_id)
          setFieldValue('workflows', defaultWorkflow)
        }
        // Trigger the same logic as manual selection
        setFieldValue('s_price', selectedRecipe?.expected_material_cost_with_markup || 0);
        setFieldValue('markupPrice', selectedRecipe?.expected_service_cost_with_markup || 0);
        
        // BACKUP: if (selectedRecipe?.expected_cost) {
        // expected_cost can be 0 for material/install-only formulas; still populate formula_cost from markup fields
        if (selectedRecipe?.expected_cost || selectedRecipe?.expected_material_cost_with_markup || selectedRecipe?.expected_service_cost_with_markup || selectedRecipe?.install_labour_cost_with_markup || selectedRecipe?.expected_cost_with_markup) {
          const totalRetailCost = inHouse === 6 ? (selectedRecipe?.expected_cost|| 0 ) : ((selectedRecipe?.expected_material_cost_with_markup || 0) + (selectedRecipe?.expected_service_cost_with_markup || 0) + (selectedRecipe?.install_labour_cost_with_markup || 0)) 
          setFieldValue('formula_cost', Number(totalRetailCost).toFixed(2))
          
          // Calculate expected_cost (without markup)
          const expectedCost = selectedRecipe?.expected_cost || 0;
          setFieldValue('expected_cost', expectedCost);
          
          // Calculate Product cost (Retail) - same logic as the disabled field
          const productCostRetail = (fromSplitEstimate || inHouse == 6) 
            ? totalRetailCost 
            : ((selectedRecipe?.expected_material_cost_with_markup || 0) + (selectedRecipe?.expected_service_cost_with_markup || 0)); // + (selectedRecipe?.expected_install_labor_cost_with_markup || 0)
          
          // Set Actual Retail Price from Product cost (Retail)
          setFieldValue('retail_price', Number(productCostRetail.toFixed(2)));
          
          // Get install labor quantity from recipe services (service_id == 10)
          if (selectedRecipe?.services && Array.isArray(selectedRecipe.services)) {
            const installLaborService = selectedRecipe.services.find(service => service.service_id == 10);
            if (installLaborService && installLaborService.quantity) {
              setFieldValue('install_labour_quantity', installLaborService.quantity);
              // Set Actual Install Price from Install Labor Cost
              // Use expected_install_labor_cost for split catalogs, install_labour_cost_with_markup for others
              // This matches the logic used in manual recipe selection
              if (fromSplitEstimate || inHouse == 6) {
                const installLaborCost = selectedRecipe?.expected_install_labor_cost || 0;
                setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
              } else {
                // Set Actual Install Price from Install Labor Cost with markup (for production/traffic catalogs)
                const installLaborCost = selectedRecipe?.install_labour_cost_with_markup || 0;
                setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
              }
            }
          }
          
          // Set retail_price with split percentage calculation for fromSplitEstimate or inHouse == 6
          if ((fromSplitEstimate || inHouse == 6) && splitPercentage) {
            const splitAmount = parseFloat(totalRetailCost) * (splitPercentage / 100);
            const finalRetailPrice = parseFloat(totalRetailCost) + splitAmount;
            setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
          }
        } else {
          setFieldValue('formula_cost', '')
          setFieldValue('expected_cost', 0)
        }
      }
    }

    // Auto-populate facility when fromSplitEstimate and targetFacilityId are provided
    if (fromSplitEstimate && targetFacilityId && filteredOtherFacilityTypes.length > 0) {
      const selectedFacility = filteredOtherFacilityTypes.find(facility => facility.id === targetFacilityId);
      if (selectedFacility) {
        setFieldValue('facility_id', selectedFacility);
        
        // Filter and set install labor cost when facility is auto-populated
        const filteredInstallLabour = otherInstallationSplitInstallLabour.filter(
          item => item.facility_id == targetFacilityId
        );
        
        if (filteredInstallLabour.length > 0) {
          const installLaborCost = filteredInstallLabour[0].total_cost;
          setFieldValue('install_labour_cost_with_markup', installLaborCost);
          
          // Calculate install_cost based on quantity and labor cost
          const quantity = values.install_labour_quantity || 0;
          const totalInstallCost = installLaborCost * quantity;
          setFieldValue('install_cost', totalInstallCost);
        }
        
        // Get split percentage from currentInstallationSplitManagementSettings for split catalog
        const splitSettings = currentInstallationSplitManagementSettings.find(
          setting => setting.id == currentFacilityId
        );
        
        if (splitSettings) {
          const facilitySplitPercentage = splitSettings.split_percentage || 0;
          setSplitPercentage(facilitySplitPercentage);
          
          // Update retail price with split percentage if formula_cost exists
          if (values.formula_cost) {
            const splitAmount = parseFloat(values.formula_cost) * (facilitySplitPercentage / 100);
            const finalRetailPrice = parseFloat(values.formula_cost) + splitAmount;
            setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
          }
        }
      }
    }
  }, [fromSplitEstimate, fromRecipeList, RecipeId, recipe, setFieldValue, splitPercentage, targetFacilityId, filteredOtherFacilityTypes, otherInstallationSplitInstallLabour, currentInstallationSplitManagementSettings, values.install_labour_quantity, values.formula_cost, inHouse])

  useEffect(() => {
    console.log("################selectedProductForCatalog", selectedProductForCatalog);
      if (selectedProductForCatalog && selectedProductForCatalog?.recipe_id) {
        let newValue = selectedProductForCatalog ? recipe.find((recipe) => recipe?.id === selectedProductForCatalog.recipe_id) : null
        console.log("################selectedProductForCatalog1", newValue);
        setFieldValue('recipe', newValue);
        if (newValue?.workflow_id) {
          let defaultWorkflow = workflows?.find(val => val.id == newValue?.workflow_id)
          setFieldValue('workflows', defaultWorkflow)
        }
        setFieldValue('s_price', newValue?.expected_material_cost_with_markup || 0);

        setFieldValue('markupPrice', newValue?.expected_service_cost_with_markup || 0)       

        // BACKUP: if (newValue?.expected_cost) {
        // expected_cost can be 0 for material/install-only formulas; still populate formula_cost from markup fields
        if (newValue?.expected_cost || newValue?.expected_material_cost_with_markup || newValue?.expected_service_cost_with_markup || newValue?.install_labour_cost_with_markup || newValue?.expected_cost_with_markup) {
          const totalRetailCost = inHouse === 6 ? (newValue?.expected_cost || 0) : ((newValue?.expected_material_cost_with_markup || 0) + (newValue?.expected_service_cost_with_markup || 0) + (newValue?.install_labour_cost_with_markup || 0))
          console.log("################Product totalRetailCost", totalRetailCost);
          setFieldValue('formula_cost', Number(totalRetailCost).toFixed(2))
          const expectedCost = newValue?.expected_cost || 0;
          setFieldValue('expected_cost', expectedCost);
          let productCostRetail = (fromSplitEstimate || inHouse == 6)
            ? totalRetailCost
            : ((newValue?.expected_material_cost_with_markup || 0) + (newValue?.expected_service_cost_with_markup || 0)); //  + (newValue?.expected_install_labor_cost_with_markup || 0)
          // Prefer saved actual_retail_price when opening from estimate job modal
          const savedActualRetail = parseFloat(
            selectedProductForCatalog?.original_actual_retail_price ??
              selectedProductForCatalog?.actual_retail_price,
          );
          if (
            selectedProductForCatalog &&
            (selectedProductForCatalog?.original_actual_retail_price != null &&
              selectedProductForCatalog?.original_actual_retail_price !== '' ||
              selectedProductForCatalog?.actual_retail_price != null &&
              selectedProductForCatalog?.actual_retail_price !== '') &&
            Number.isFinite(savedActualRetail)
          ) {
            productCostRetail = Math.max(savedActualRetail, productCostRetail);
          }
          setFieldValue('retail_price', Number(productCostRetail.toFixed(2)));
          if (newValue?.services && Array.isArray(newValue.services)) {
            const installLaborService = newValue.services.find(service => service.service_id == 10);
            if ((fromSplitEstimate || inHouse == 6) && installLaborService && installLaborService.quantity) {
              setFieldValue('install_labour_quantity', installLaborService.quantity);
              const installLaborCost = newValue?.expected_install_labor_cost || 0;
              setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
            } else if (!fromSplitEstimate && inHouse != 6) {
              let installLaborCost = newValue?.install_labour_cost_with_markup || 0;
              const savedInstallCost = parseFloat(
                selectedProductForCatalog?.original_install_cost ??
                  selectedProductForCatalog?.install_cost,
              );
              if (
                selectedProductForCatalog &&
                (selectedProductForCatalog?.original_install_cost != null &&
                  selectedProductForCatalog?.original_install_cost !== '' ||
                  selectedProductForCatalog?.install_cost != null &&
                  selectedProductForCatalog?.install_cost !== '') &&
                Number.isFinite(savedInstallCost)
              ) {
                installLaborCost = Math.max(savedInstallCost, installLaborCost);
              }
              setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
            }
          }

          // Set retail_price with split percentage calculation for fromSplitEstimate or inHouse == 6
          if ((fromSplitEstimate || inHouse == 6) && splitPercentage) {
            const splitAmount = parseFloat(totalRetailCost) * (splitPercentage / 100);
            const finalRetailPrice = parseFloat(totalRetailCost) + splitAmount;
            setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
          }
        } else {
          setFieldValue('formula_cost', '')
          setFieldValue('expected_cost', 0)
          if (fromSplitEstimate) {
            setFieldValue('retail_price', '')
          }
        }
      }
    if(selectedProductForCatalog?.workflowIds && selectedProductForCatalog?.workflowIds?.length > 0){
      axios.post(`${REST_API_END_POINT}onboard/get-all-workflows-products-by-workflow-ids`, { workflowIds: selectedProductForCatalog?.workflowIds })
      .then((res) => {
        console.log("################selectedProductForCatalog2", res.data.result);
          if(res.data.result && res.data.result?.length > 0){
            const sortedWorkflows = [...(res.data.result || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
            setWorkflows(sortedWorkflows);
          }
      })
      .catch((error) => {
        console.log("################selectedProductForCatalog2", error);
      })
    }
  }, [selectedProductForCatalog,recipe])

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setSelectedFile(file);
        setFieldValue('avatarUrl', {
          ...file,
          preview: URL.createObjectURL(file)
        });
      }
    },
    [setFieldValue]
  );

  const handleThumbnailDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setSelectedThumbnail(file);
        setFieldValue('thumbnail', {
          ...file,
          preview: URL.createObjectURL(file)
        });
      }
    },
    [setFieldValue]
  );

const populateFormFields = (newValue) => {
  if (newValue) {
    console.log('newValueeeeee', newValue);
    setFieldValue('newProductId', newValue.id || null);
    // Calculate expected price
    const retail_cost = parseFloat(newValue.retail_price) || 0;
    const install_cost = parseFloat(newValue.install_cost) || 0;
    const expectedPrice = newValue.inhouse === 0 
                          ? newValue.sub_contract_price || 0 
                          : retail_cost - install_cost;

    // Populate form fields using setFieldValue
    setFieldValue('ul_number', newValue.ul_number || '');
    const rowDescription =
      selectedProductForCatalog?.product_desc ||
      selectedProductForCatalog?.description ||
      '';
    setFieldValue(
      'description',
      rowDescription || newValue.description || newValue.product_desc || '',
    );
    setFieldValue('price', newValue.price || '');
    // Actual Retail Price must use actual_retail_price (not combined retail_price)
    const savedActualRetailPrice = parseFloat(newValue.actual_retail_price);
    const fallbackActualRetail =
      Number.isFinite(savedActualRetailPrice) &&
      newValue.actual_retail_price != null &&
      newValue.actual_retail_price !== ''
        ? savedActualRetailPrice
        : retail_cost - install_cost;
    setFieldValue('retail_price', Number.isFinite(fallbackActualRetail) ? fallbackActualRetail : 0);
    setFieldValue('install_cost', newValue.install_cost || 0);
    setFieldValue('formula_cost', newValue.formula_cost || '');
    setFieldValue('s_price', newValue.s_price || 0);
    setFieldValue('markupPrice', newValue.markupPrice || 0);
    setFieldValue('category', newValue.category_id || null);  // Set category first
    // setFieldValue('unit', newValue?.unit || 4);
    setFieldValue('sub_category', newValue.sub_category_id || null);  // Set subcategory second
    setFieldValue('workflows', newValue.workflow || null);
    setFieldValue('recipe_id', newValue.recipe || null);
    setFieldValue('isTrafficCatalog', newValue.isTrafficCatalog || false);
    setFieldValue('markup', newValue.markup || null);
    setFieldValue('sub_contract_price', newValue.sub_contract_price || 0);
    setFieldValue('in_stock_no', newValue.in_stock_no || '');
    setFieldValue('taxCodeId', newValue.taxCodeId || null);
    setFieldValue('taxCode', newValue.taxCode || '');
    setFieldValue('facility_id', newValue.facility_id || null);
    setFieldValue('install_labour_quantity', newValue.install_labour_quantity || 0);
    setFieldValue('expected_cost', newValue.expected_cost || 0);
    setFieldValue('lead_time', newValue.lead_time || '');
    setFieldValue('bin_location', newValue.bin_location || '');
    if (newValue.vendor_id) {
      const vendorId = Number(String(newValue.vendor_id).split(',')[0]);
      setFieldValue('vendor', String(vendorId));
    } else {
      setFieldValue('vendor', '');
    }
    setFieldValue('expected_price', expectedPrice); // Set the expected price for the product
    

    // Populate subcategory (if available)
    if (newValue.category_id) {
      const newCategory = category.find(data => data.id === newValue.category_id);
      setFieldValue('category', newCategory || null);  // Ensure category is set
      // Now set the subcategory
      if (newValue.category_id) {
        axios
          .post(`${REST_API_END_POINT}product/get-subcategory`, { id: newValue.category_id })
          .then((res) => {
            const sortedSubCategories = [...(res.data.data || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''));
            setSubCategory(sortedSubCategories);
            
            // Populate subcategory if an ID is already available
            if (newValue.sub_category_id) {
              const newSubCategory = sortedSubCategories.find((data) => data.id === newValue.sub_category_id);
              setFieldValue('sub_category', newSubCategory || null);
            }
          })
          .catch((error) => {
            console.error('Error fetching subcategories:', error);
          });
      }
      // if (newValue.sub_category_id) {
      //   const newSubCategory = subCategory.find(data => data.id === newValue.sub_category_id);
      //   setFieldValue('sub_category', newSubCategory || null);  // Set subcategory after category
      // }
    }

    // Populate workflow (if available)
    if (newValue.workflow) {
      const NewWorkflows = workflows.find(data => data.id === newValue.workflow);
      setFieldValue('workflows', NewWorkflows || null);
    }

    // Populate product formula (if available)
    // if (newValue.recipe_id) {
    //   const newRecipe = recipe.find(data => data.id === newValue.recipe_id);
    //   setFieldValue('recipe', newRecipe || null);
    // }

    if (newValue.recipe_id) {
      const newRecipe = recipe.find(data => data.id === newValue.recipe_id);
      setFieldValue('recipe', newRecipe || null);
    
      // If a new recipe is selected, perform the necessary calculations
      if (newRecipe) {
        // Set the s_price (expected material cost with markup)
        setFieldValue('s_price', newRecipe?.expected_material_cost_with_markup || 0);
        
        // Set markupPrice (expected service cost with markup)
        setFieldValue('markupPrice', newRecipe?.expected_service_cost_with_markup || 0);
    
        // Handle formula cost and retail price calculations
        // BACKUP: if (newRecipe?.expected_cost) {
        // expected_cost can be 0 for material/install-only formulas; still populate formula_cost from markup fields
        if (newRecipe?.expected_cost || newRecipe?.expected_material_cost_with_markup || newRecipe?.expected_service_cost_with_markup || newRecipe?.install_labour_cost_with_markup || newRecipe?.expected_cost_with_markup) {
          // Calculate total retail cost based on inHouse or split estimate logic
          const totalRetailCost = inHouse === 6 
            ? (newRecipe?.expected_cost || 0) 
            : ((newRecipe?.expected_material_cost_with_markup || 0) + 
               (newRecipe?.expected_service_cost_with_markup || 0) + 
               (newRecipe?.install_labour_cost_with_markup || 0));
    
          console.log("################Product totalRetailCost", totalRetailCost);
    
          // Set the formula cost
          setFieldValue('formula_cost', Number(totalRetailCost).toFixed(2));
          
          // Set the expected cost (without markup)
          const expectedCost = newRecipe?.expected_cost || 0;
          setFieldValue('expected_cost', expectedCost);
    
          // Calculate Product cost (Retail) - same logic as the disabled field
          const productCostRetail = (fromSplitEstimate || inHouse == 6) 
            ? totalRetailCost 
            : ((newRecipe?.expected_material_cost_with_markup || 0) + 
               (newRecipe?.expected_service_cost_with_markup || 0));
    
          // Keep saved Actual Retail Price when selecting an existing catalog product
          const savedActualFromProduct = parseFloat(newValue.actual_retail_price);
          const retailToSet =
            Number.isFinite(savedActualFromProduct) &&
            newValue.actual_retail_price != null &&
            newValue.actual_retail_price !== ''
              ? Math.max(savedActualFromProduct, productCostRetail)
              : productCostRetail;
          setFieldValue('retail_price', Number(retailToSet.toFixed(2)));
    
          // Get install labor quantity from recipe services (service_id == 10)
          if (newRecipe?.services && Array.isArray(newRecipe.services)) {
            const installLaborService = newRecipe.services.find(service => service.service_id == 10);
            if ((fromSplitEstimate || inHouse == 6) && installLaborService && installLaborService.quantity) {
              setFieldValue('install_labour_quantity', installLaborService.quantity);
              
              // Set the Actual Install Price from Install Labor Cost
              const installLaborCost = newRecipe?.expected_install_labor_cost || 0;
              setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
            } else if (!fromSplitEstimate && inHouse != 6) {
              // Keep saved Actual Install Price when selecting an existing catalog product
              const recipeInstallCost = newRecipe?.install_labour_cost_with_markup || 0;
              const savedInstallFromProduct = parseFloat(newValue.install_cost);
              const installToSet =
                Number.isFinite(savedInstallFromProduct) &&
                newValue.install_cost != null &&
                newValue.install_cost !== ''
                  ? Math.max(savedInstallFromProduct, recipeInstallCost)
                  : recipeInstallCost;
              setFieldValue('install_cost', Number(installToSet.toFixed(2)));
            }
          }
    
          // Set retail_price with split percentage calculation for fromSplitEstimate or inHouse == 6
          if ((fromSplitEstimate || inHouse == 6) && splitPercentage) {
            const splitAmount = parseFloat(totalRetailCost) * (splitPercentage / 100);
            const finalRetailPrice = parseFloat(totalRetailCost) + splitAmount;
            setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
          }
        } else {
          // If the recipe doesn't have expected_cost, reset relevant fields
          setFieldValue('formula_cost', '');
          setFieldValue('expected_cost', 0);
          if (fromSplitEstimate) {
            setFieldValue('retail_price', '');
          }
        }
      }
    }    
    
  }
};

  // Auto-populate fields when a currentCatalogId is provided (pre-linked catalog from estimate row)
  useEffect(() => {
    if (!isFromEstimateJob || !currentCatalogId || !allProducts || allProducts.length === 0) return;
    // Wait until recipes are also loaded so populateFormFields can resolve the recipe
    if (isRecipeLoading) return;
    const matchedProduct = allProducts.find(
      (p) => Number(p.id) === Number(currentCatalogId)
    );
    if (matchedProduct) {
      populateFormFields(matchedProduct);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCatalogId, allProducts, isRecipeLoading]);


  
  const UploadImage = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    // console.log("typeof(selectedFile) : ", typeof (selectedFile))
  }
  const handleCategory = async (data) => {
    console.log('data---', data);
    if (data) {
      setFieldValue('category', data)
      setFieldValue('sub_category', null)
      // setFieldValue('retail_price', '')
      // setFieldValue('price', '')
      //////////////////////////////////////previos retail and wholesale markup calculation
      // if (data?.markup >= 0) {
      //   const totalRetailCost = (values?.markupPrice || 0) + (values?.s_price || 0) + ((values?.s_price || 0) * data?.markup / 100)
      //   setFieldValue('retail_price', totalRetailCost?.toFixed(2))
      // } else {
      //   setFieldValue('retail_price', '')
      // }
      // if (data?.wholesale_markup >= 0) {
      //   const totalWholesaleCost = (values?.markupPrice || 0) + (values?.s_price || 0) + ((values?.s_price || 0) * data?.wholesale_markup / 100)
      //   setFieldValue('price', totalWholesaleCost?.toFixed(2))
      // } else {
      //   setFieldValue('price', '')
      // }
      ///////////////////////////////////////
      // if(values?.price && data?.markup){
      //   const WholesalePrice = Number(values?.price)
      //   const totalRetailCost = WholesalePrice  + (WholesalePrice * data?.markup / 100)
      //   setFieldValue('retail_price',totalRetailCost)
      // }else{
      //   setFieldValue('retail_price','')
      // }
      axios.post(`${REST_API_END_POINT}product/get-subcategory`, { id: data?.id })
        .then((res) => {
          // Sort alphanumerically by name
          const sortedSubCategories = [...(res.data.data || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
          setSubCategory(sortedSubCategories)
        })
        .catch((error) => {
          console.log(error)
        })
    } else {
      setFieldValue('category', null)
      setFieldValue('sub_category', null)
      // setFieldValue('retail_price', '')
      // setFieldValue('price', '')
      setSubCategory([])
    }
  }

  const handleSubCategory = async (data)=>{
  if(data){
  setFieldValue('sub_category', data)
  console.log('subcategory',data)
  //////////////////////////////15/01/25 from now the retail markup came from product formula
  // if(data.markup==null && data.wholesale_markup==null){
  //   // setFieldValue('retail_price', '')
  //   // setFieldValue('price', '')
  // }else{

  
  // if (data?.markup >= 0) {
  //   const totalRetailCost = (values?.markupPrice || 0) + (values?.s_price || 0) + ((values?.s_price || 0) * data?.markup / 100)
  //   setFieldValue('retail_price', totalRetailCost?.toFixed(2))
  // } else {
  //   setFieldValue('retail_price', '')
  // }
/////////////////////////////////

  // currently no need of wholesale 14-01-25
  // if (data?.wholesale_markup >= 0) {
  //   const totalWholesaleCost = (values?.markupPrice || 0) + (values?.s_price || 0) + ((values?.s_price || 0) * data?.wholesale_markup / 100)
  //   setFieldValue('price', totalWholesaleCost?.toFixed(2))
  // } else {
  //   setFieldValue('price', '')
  // }
// }
  }else{
    setFieldValue('sub_category', null)
    // setFieldValue('retail_price', '')
    // setFieldValue('price', '')
  }

  }
  const handleInputChange = (event, newInputValue) => {
    setInputValue(newInputValue)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && inputValue.trim() !== '') {
      setTags([...tags, inputValue.trim()])
      setInputValue('')
    }
  }

  const handleDelete = (tagToDelete) => {
    setTags((prevTags) => prevTags?.filter((tag) => tag !== tagToDelete))
  }

  const handleRecipeCreated = async (newRecipe) => {
    setOpenRecipeModal(false);
    
    // Fetch recipes and find the new one
    try {
      const res = await axios.post(REST_API_END_POINT + 'product/get-all-recipes');
      if (res.data.status === 1) {
        const filteredData = res.data.recipes.filter((recipe) => 
          isTrafficCatalog ? recipe?.type === 2 : (fromSplitEstimate || inHouse == 6) ? recipe?.type === 3 : recipe?.type === 1
        ) || res.data.recipes;
        // Sort alphanumerically by name
        const sortedData = [...filteredData].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setRecipe(sortedData);
        
        const newRecipeData = filteredData.find(r => r.id === newRecipe.id);
        if (newRecipeData) {
          setFieldValue('recipe', newRecipeData);
          setFieldValue('s_price', newRecipeData?.expected_material_cost_with_markup || 0);
          setFieldValue('markupPrice', newRecipeData?.expected_service_cost_with_markup || 0);
          
          // BACKUP: if (newRecipeData?.expected_cost) {
          // expected_cost can be 0 for material/install-only formulas; still populate formula_cost from markup fields
          if (newRecipeData?.expected_cost || newRecipeData?.expected_material_cost_with_markup || newRecipeData?.expected_service_cost_with_markup || newRecipeData?.install_labour_cost_with_markup || newRecipeData?.expected_cost_with_markup) {
            const totalRetailCost = inHouse === 6 ? (newRecipeData?.expected_cost || 0) : ((newRecipeData?.expected_material_cost_with_markup || 0) + (newRecipeData?.expected_service_cost_with_markup || 0) + (newRecipeData?.install_labour_cost_with_markup || 0));
            setFieldValue('formula_cost', Number(totalRetailCost).toFixed(2));
            setFieldValue('expected_cost', newRecipeData?.expected_cost || 0);
            
            // Calculate Product cost (Retail) - same logic as the disabled field
            const productCostRetail = (fromSplitEstimate || inHouse == 6) 
              ? totalRetailCost 
              : ((newRecipeData?.expected_material_cost_with_markup || 0) + (newRecipeData?.expected_service_cost_with_markup || 0)); // + (newRecipeData?.expected_install_labor_cost_with_markup || 0)
            
            // Set Actual Retail Price from Product cost (Retail)
            setFieldValue('retail_price', Number(productCostRetail.toFixed(2)));
            
            // Get install labor quantity from recipe services (service_id == 10)
            if (newRecipeData?.services && Array.isArray(newRecipeData.services)) {
              const installLaborService = newRecipeData.services.find(service => service.service_id == 10);
              if ((fromSplitEstimate || inHouse == 6) && installLaborService && installLaborService.quantity) {
                setFieldValue('install_labour_quantity', installLaborService.quantity);
                // Set Actual Install Price from Install Labor Cost
                const installLaborCost = newRecipeData?.expected_install_labor_cost || 0;
                setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
              } else if (!fromSplitEstimate && inHouse != 6) {
                // Set Actual Install Price from Install Labor Cost
                const installLaborCost = newRecipeData?.install_labour_cost_with_markup || 0;
                setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
              }
            }
            
            // Set retail_price with split percentage calculation for fromSplitEstimate or inHouse == 6
            if ((fromSplitEstimate || inHouse == 6) && splitPercentage) {
              const splitAmount = parseFloat(totalRetailCost) * (splitPercentage / 100);
              const finalRetailPrice = parseFloat(totalRetailCost) + splitAmount;
              setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
            }
          }

          // Refetch workflows and match the associated workflow if present
          try {
            const workflowRes = await axios.post(`${REST_API_END_POINT}onboard/get-all-workflows-products`);
            if (workflowRes?.data?.result) {
              const sortedWorkflows = [...(workflowRes.data.result || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''));
              setWorkflows(sortedWorkflows);

              const recipeWorkflowId = newRecipeData?.workflow_id || newRecipe?.workflow_id;
              if (recipeWorkflowId) {
                const matchedWorkflow = sortedWorkflows.find(w => w.id == recipeWorkflowId);
                if (matchedWorkflow) {
                  setFieldValue('workflows', matchedWorkflow);
                }
              }
            }
          } catch (workflowError) {
            console.error('Error fetching workflows during recipe creation:', workflowError);
          }
        }
      }
    } catch (error) {
      console.error('Error fetching recipes:', error);
    }
  }
  const handleWorkflowCreated = async (newWorkflow,workflowIds) => {
    setOpenWorkflowModal(false);
    
    // Fetch workflows and find the new one
    try {
      const res = await axios.post(`${REST_API_END_POINT}onboard/${workflowIds ? 'get-all-workflows-products-by-workflow-ids' : 'get-all-workflows-products'}`, { workflowIds: workflowIds });
      if (res?.data?.result) {
        // Sort alphanumerically by name
        const sortedWorkflows = [...(res.data.result || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setWorkflows(sortedWorkflows);
        
        const newWorkflowData = sortedWorkflows.find(r => r.id === newWorkflow);
        if (newWorkflowData) {
          setFieldValue('workflows', newWorkflowData);
        }
      }
    } catch (error) {
      console.error('Error fetching workflows:', error);
    }
  }

  const handleCombineWorkflowOnly = async () => {
    try {
      const groupProductIds = Array.isArray(selectedProductForCatalog?.productIds)
        ? selectedProductForCatalog.productIds.map((id) => Number(id)).filter((id) => !Number.isNaN(id))
        : [];
      if (groupProductIds.length === 0) {
        enqueueSnackbar('No grouped products found to combine workflow.', { variant: 'warning' });
        return;
      }

      // const groupedProducts = Array.isArray(allProducts)
      //   ? allProducts.filter((p) => groupProductIds.includes(Number(p?.id)))
      //   : [];
      // const workflowIds = groupedProducts
      //   .map((p) => Number(p?.workflow ?? p?.workflow_id))
      //   .filter((id) => !Number.isNaN(id) && id > 0);
      // if (workflowIds.length === 0) {
      //   enqueueSnackbar('No workflows found on grouped products.', { variant: 'warning' });
      //   return;
      // }

      setIsCombiningWorkflow(true);
      const response = await axios.post(`${REST_API_END_POINT}product/combine-group-catalog-workflow`, {
        // groupId: selectedProductForCatalog?.groupId || null,
        productIds: groupProductIds,
        groupData: {
          group_name: selectedProductForCatalog?.name || values?.name || 'Estimate Group',
          group_description: selectedProductForCatalog?.description || values?.description || '',
          group_addresses: null,
        },
        request_id: selectedProductForCatalog?.requestId || null,
        workflowIds: selectedProductForCatalog?.workflowIds || [],
        recipeIds: selectedProductForCatalog?.recipeIds || [],
        combaineWorkflow: true,
      });

      if (response?.data?.status === 200 && response?.data?.data?.workflow) {
        let workflowIds = [...(selectedProductForCatalog?.workflowIds || []),response.data.data.workflow] || [];
        console.log("################workflowIds", workflowIds);
        await handleWorkflowCreated(response.data.data.workflow,workflowIds);
        enqueueSnackbar('Workflow combined successfully.', { variant: 'success' });
      } else {
        enqueueSnackbar(response?.data?.message || 'Failed to combine workflow.', { variant: 'error' });
      }
    } catch (error) {
      console.error('Combine workflow error:', error);
      enqueueSnackbar('Failed to combine workflow.', { variant: 'error' });
    } finally {
      setIsCombiningWorkflow(false);
    }
  }

  const handleCancel=()=>{
    if ((fromSplitEstimate || fromRecipeList) && onClose) {
      onClose();
    } else {
      // navigate(PATH_DASHBOARD.products.main,{state:{
      //   in_house:inHouse?'in_house':'sub_contract'
      // }});
      navigate(PATH_DASHBOARD.products.main,{state:{
        in_house:isTrafficCatalog ? 1 : selectedTab === 'in_stock_catalog' ? 4 : selectedTab === 'client_owned_catalog' ? 5 : selectedTab === 'split_catalog' ? 6 : selectedTab === 'estimate_catalog' ? 7 : inHouse ? true : false,listPage: listPage,rowsPerPage: rowsPerPage

      }});
    }
  }
  return (
    <Page title="Add Catalog | Sign-Wise Solution">
      <Container>
        {fromRecipeList ? '' :
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <HeaderBreadcrumbs
            heading=" Add Catalog"
          /></Stack>}
          {timeMaterial? 
          <AddTimeAndMaterialProduct timeMaterial={timeMaterial}/>
          :
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Dialog
              open={openBackConfirmDialog}
              onClose={handleBackConfirmClose}
              aria-labelledby="back-autosave-dialog-title"
            >
              <DialogTitle id="back-autosave-dialog-title">Go back?</DialogTitle>
              <DialogContent>
                <Typography>
                  Do you want to auto save this Catalog before going back?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleBackConfirmYes}
                  color="primary"
                  variant="contained"
                >
                  Yes, Auto Save
                </Button>
                <Button onClick={handleBackConfirmNo} color="inherit">
                  No, Go Back
                </Button>
              </DialogActions>
            </Dialog>

            <Grid container spacing={1} justifyContent="center" alignItems="center">
               
              {/* <Grid item xs={12} md={4}>
                <Card sx={{ py: 20, px: 3 }}>
                
                  <Box sx={{ mb: 5 }}>
                    <LabelStyle></LabelStyle>
                    <UploadAvatar
                      accept="image/*"
                      file={values.avatarUrl}
                      maxSize={1024 * 1024 * 1024}
                      type="file"
                      onDrop={handleDrop}
                      error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                      caption={
                        <Typography
                          variant="caption"
                          sx={{
                            mt: 2,
                            mx: 'auto',
                            display: 'block',
                            textAlign: 'center',
                            color: 'text.secondary'
                          }}
                        >
                          Allowed *.jpeg, *.jpg, *.png, *.gif
                          <br /> max size of {fData(14680064)}
                        </Typography>
                      }
                    />

                    <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
                      {touched.avatarUrl && errors.avatarUrl}
                    </FormHelperText>
                    

                  </Box>

                </Card>
              </Grid> */}
              <Grid item xs={12} md={12}>
              <Typography variant='h6' gutterBottom>
                  {/* {inHouse ? "In House" : "Sub Contract"} */}
                    {isTrafficCatalog
                      ? "Traffic Catalog"
                      : inHouse === 5
                        ? "Client Owned Catalog"
                      : inHouse === 4
                      ? "In Stock Catalog"
                      : inHouse === 6
                        ? "Split Catalog"
                      : inHouse === 7
                        ? "Estimate Catalog"
                        : inHouse
                          ? "Production Catalog"
                          : "Sub Contract"}

              </Typography>
              {
                isFromEstimateJob ?
              <Box sx={{ px:5 ,py:2 ,margin: 'auto', overflow: 'auto', bgcolor: 'background.paper' }}>
                <Stack direction="row" alignItems="center" spacing={2}>
                {
                  isRecipeLoading ?
                  <TextField
                  disabled
                  sx={{ width: '50%' }}
                  label="Loading products..."
                  InputProps={{
                    endAdornment: <CircularProgress size={20} />,
                  }}
                />
                :
                <Autocomplete
                  sx={{ width: '50%' }}
                  id="combo-box-demo"
                  options={filteredProductOptions}
                  value={(() => {
                    const preselectId =
                      values?.newProductId ||
                      selectedProductForCatalog?.product_id ||
                      selectedProductForCatalog?.id ||
                      currentCatalogId;
                    if (
                      preselectId == null ||
                      preselectId === '' ||
                      Number.isNaN(Number(preselectId))
                    ) {
                      return null;
                    }
                    return (
                      filteredProductOptions.find(
                        (option) => Number(option.id) === Number(preselectId)
                      ) || null
                    );
                  })()}
                  isOptionEqualToValue={(option, value) => Number(option.id) === Number(value?.id)}
                  // getOptionLabel={(option) => option.name ? option.name : ''}
                  getOptionLabel={(option) => {
                    const name = option.product_name || option.name || '';
                    const catalogType =
                      option.isTrafficCatalog
                        ? '(TC)'
                        : option.inhouse === 5
                        ? '(Client Owned Catalog)'
                        : option.inhouse === 4
                        ? '(In Stock Catalog)'
                        : option.inhouse === 0
                        ? '(Sub Contract)'
                        : option.inhouse === 6
                        ? '(Split Catalog)'
                        : option.inhouse === 7
                        ? '(Estimate Catalog)'
                        : '(Production Catalog)';
                
                    return `${name} ${catalogType}`; // Display product name and catalog type
                  }}
                  onChange={(event, newValue) => {
                    populateFormFields(newValue);
                  }}
                  filterOptions={(options, { inputValue }) => {
                    const normalizeText = (value) =>
                      (value || '')
                        .toString()
                        .toLowerCase()
                        .replace(/\s+/g, ' ')
                        .trim();

                    const searchValue = normalizeText(inputValue);

                    const matchesSearch = (value) => {
                      const normalizedValue = normalizeText(value);
                      if (!searchValue) return true;
                      return normalizedValue.includes(searchValue);
                    };

                    return options.filter((option) => {
                      const name = option.product_name || option.name || '';
                      const catalogType =
                        option.isTrafficCatalog
                          ? '(TC)'
                          : option.inhouse === 5
                          ? '(Client Owned Catalog)'
                          : option.inhouse === 4
                          ? '(In Stock Catalog)'
                          : option.inhouse === 0
                          ? '(Sub Contract)'
                          : option.inhouse === 6
                          ? '(Split Catalog)'
                          : option.inhouse === 7
                          ? '(Estimate Catalog)'
                          : '(Production Catalog)';
                      const displayLabel = `${name} ${catalogType}`;
                      const idMatches = matchesSearch(option.id);
                      const nameMatches = matchesSearch(displayLabel);
                      const normalizedTags = Array.isArray(option.tags)
                        ? option.tags.join(' ')
                        : option.tags;
                      const tagsMatch = matchesSearch(normalizedTags);
                      return idMatches || nameMatches || tagsMatch;
                    });
                  }}
                  renderInput={(params) => <TextField {...params} label="Select a Product" />}
                />
                }
                <Autocomplete
                  sx={{ width: '50%' }}
                  id="normal-catalog-type"
                  options={splitOrderCatalogTypes}
                  value={splitOrderCatalogTypes.find(type => type.id === selectedCatalogType)}
                  onChange={(event, newValue) => {
                    const catalogType = newValue ? newValue.id : 'all'; // Default to 'all' if no value
                    setSelectedCatalogType(catalogType);  // Update the selected catalog type
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Catalog Type"
                      placeholder="Select catalog type"
                    />
                  )}
                  getOptionLabel={(option) => option.label}
                />
                </Stack>
                </Box> : ''
              }
                {selectedProductForCatalog?.addExistingEstimateCatalog ? '' : <Card sx={{ p:5 ,margin: 'auto',height: '70vh', overflow: 'auto', bgcolor: 'background.paper',boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)', }}>
                  {/* <FormControlLabel
                    control={
                      <Switch
                        checked={inHouse}
                         onChange={() => { setInHouse(!inHouse) }}
                      />
                    }
                    label={inHouse ? "In House" : "Sub Contract"}
                  /> */}
                  <Stack spacing={3} sx={{ bgcolor: 'background.paper', boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)', }}>
                          <Stack
                            key="product-info-header"
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                            sx={{
                              position: 'sticky',
                              top: "-42px",
                              paddingTop: "17px",
                              zIndex: 2,  // Keeps it above other content
                              bgcolor: 'background.paper',
                              boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
                              paddingBottom: 2,  // Prevents overlap with the next section
                            }}
                          >
                      <TextField
                        required
                        fullWidth
                        label="Name"
                        type="text"
                        {...getFieldProps('name')}
                        // value={values.name}
                        // onChange={(name)=>setFieldValue('name',name)}
                        error={Boolean(touched.name && errors.name)}
                        helperText={touched.name && errors.name}
                      />
                      {/* <TextField
                          fullWidth
                          label="SKU"
                          // type="number"
                          {...getFieldProps('vpt_number')}
                          // onKeyDown={(e) => {
                          //   const invalidKeys = ['ArrowUp', 'ArrowDown',  '-', 'e', '+'];
                          //   if (invalidKeys.includes(e.key)) {
                          //     e.preventDefault();
                          //   }
                          // }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                              </InputAdornment>
                            ),
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value
                            // e.target.value = e.target.value.replace(/[^0-9]/g, '');
                          }}
                          error={Boolean(touched.vpt_number && errors.vpt_number)}
                          helperText={touched.vpt_number && errors.vpt_number}
                        />  */}
                      <TextField
                        fullWidth
                        label="UL #"
                        {...getFieldProps('ul_number')}
                        onChange={handleChange}
                      />
                      </Stack>

                      {!inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog' && (
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Autocomplete
                            fullWidth
                            id="sub-contract-vendor"
                            options={vendors}
                            value={vendors?.find((option) => option.id === values.vendor) || null}
                            onChange={(event, newValue) => setFieldValue('vendor', newValue?.id ? String(newValue.id) : '')}
                            isOptionEqualToValue={(option, value) => option.id === (value?.id ?? value)}
                            getOptionLabel={(option) => option.name || ''}
                            renderOption={(props, option) => (
                              <li {...props}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  {(option?.syncWithQuickBook === 1 || option?.syncWithQuickbooks === 1) ? (
                                    <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover" }} />
                                  ) : (
                                    <Avatar sx={{ width: 30, height: 30, objectFit: "cover" }} />
                                  )}
                                  <span>{option.name}</span>
                                </Box>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Vendor"
                                error={Boolean(touched.vendor && errors.vendor)}
                                helperText={touched.vendor && errors.vendor}
                              />
                            )}
                          />
                        </Stack>
                      )}
                        
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                        required
                        multiline
                        minRows={3}
                        fullWidth
                        label="Description"
                        type="text"
                        {...getFieldProps('description')}
                        // value={values.description}
                        // onChange={(description)=>setFieldValue("description",description)}
                        error={Boolean(touched.description && errors.description)}
                        helperText={touched.description && errors.description}
                      />
                    </Stack>
                    
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <Box sx={{ width: '100%' }}>
                        <LabelStyle>Thumbnail Image</LabelStyle>
                        <UploadSingleFile
                          accept="image/*"
                          fullImage={true}
                          allowDownload
                          file={values.thumbnail && values.thumbnail !== 'default.jpg' ? values.thumbnail : null}
                          maxSize={1024 * 1024 * 1024}
                          onDrop={handleThumbnailDrop}
                          error={Boolean(touched.thumbnail && errors.thumbnail)}
                          caption={
                            <Typography
                              variant="caption"
                              sx={{
                                mt: 2,
                                mx: 'auto',
                                display: 'block',
                                textAlign: 'center',
                                color: 'text.secondary'
                              }}
                            >
                              Allowed *.jpeg, *.jpg, *.png, *.gif
                              <br /> max size of {fData(14680064)}
                            </Typography>
                          }
                        />
                        <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
                          {touched.thumbnail && errors.thumbnail}
                        </FormHelperText>
                      </Box>
                    </Stack>
                    
                    {(inHouse || isTrafficCatalog || selectedTab === 'split_catalog') &&
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      {/* <div>
                        <InputLabel htmlFor="material-cost">Select a recipe *</InputLabel> */}
                      <Box sx={{ display: 'flex', gap: 2, width: '100%', alignItems: 'center' }}>
                        <Autocomplete 
                          sx={{ flex: 1 }}
                          id="combo-box-demo"
                          options={recipe}
                          PaperComponent={({ children, ...paperProps }) => (
                            <Paper {...paperProps}>
                              {children}
                              {isRecipeLoading ? (
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                    py: 1.25,
                                    borderTop: '1px solid',
                                    borderColor: 'divider',
                                  }}
                                >
                                  <CircularProgress color="inherit" size={18} />
                                  <Typography variant="caption" color="textSecondary">
                                    Loading formulas…
                                  </Typography>
                                </Box>
                              ) : null}
                            </Paper>
                          )}
                          value={values.recipe}
                        // onChange={(event, newValue) => {
                        //   if (newValue) {
                        //     console.log("################Product recipeeeeeeeeeee", newValue);
                        //     setFieldValue('recipe', newValue);
                        //     // setFieldValue('s_price', newValue?.expected_cost);
                        //     setFieldValue('s_price', newValue?.expected_material_cost);

                        //     // setFieldValue('markupPrice',newValue?.expected_material_cost + newValue?.expected_total_service_cost)
                        //     setFieldValue('markupPrice', newValue?.expected_total_service_cost)
                        //     if (newValue?.expected_cost && values?.category?.wholesale_markup >= 0) {
                        //       const totalWholesaleCost = (newValue?.expected_material_cost + newValue?.expected_total_service_cost) + ((newValue?.expected_material_cost) * values?.category?.wholesale_markup / 100)
                        //       setFieldValue('price', totalWholesaleCost.toFixed(2))
                        //       console.log("################Product totalWholesaleCost", totalWholesaleCost);
                        //     } else {
                        //       setFieldValue('price', '')
                        //     }
                        //     if (newValue?.expected_cost && values?.category?.markup >= 0) {
                        //       const totalRetailCost = (newValue?.expected_material_cost + newValue?.expected_total_service_cost) + (((newValue?.expected_material_cost)) * values?.category?.markup / 100)
                        //       console.log("################Product totalRetailCost", totalRetailCost);
                        //       setFieldValue('retail_price', totalRetailCost.toFixed(2))
                        //     } else {
                        //       setFieldValue('retail_price', '')
                        //     }
                        //   } else {
                        //     setFieldValue('recipe', null);
                        //     setFieldValue('s_price', '');
                        //     setFieldValue('price', '');
                        //     setFieldValue('retail_price', '');
                        //   }
                        // }}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            console.log("################Product recipeeeeeeeeeee", newValue);
                            setFieldValue('recipe', newValue);
                            if(newValue?.workflow_id){
                              let defaultWorkflow = workflows?.find(val => val.id == newValue?.workflow_id)
                              setFieldValue('workflows', defaultWorkflow)
                            }
                            // setFieldValue('s_price', newValue?.expected_cost);
                            // setFieldValue('s_price', newValue?.expected_material_cost); previos without markup
                            setFieldValue('s_price', newValue?.expected_material_cost_with_markup || 0);
                            
                           

                            // setFieldValue('markupPrice',newValue?.expected_material_cost + newValue?.expected_total_service_cost)
                            // setFieldValue('markupPrice', newValue?.expected_total_service_cost)
                            setFieldValue('markupPrice', newValue?.expected_service_cost_with_markup || 0)
                            // currently there is no need of markup 14-01-2024
                            // if (newValue?.expected_cost && values?.sub_category?.wholesale_markup >= 0 && values?.sub_category?.wholesale_markup !==null) {
                            //   const totalWholesaleCost = (newValue?.expected_material_cost + newValue?.expected_total_service_cost) + ((newValue?.expected_material_cost) * values?.sub_category?.wholesale_markup / 100)
                            //   setFieldValue('price', totalWholesaleCost.toFixed(2))
                            //   console.log("################Product totalWholesaleCost", totalWholesaleCost);
                            // } else {
                            //   setFieldValue('price', '')
                            // }
                            //previos retail mrkup calculation based on sub cat
                            // if (newValue?.expected_cost && values?.sub_category?.markup >= 0 && values?.sub_category?.markup !==null) {
                            //   const totalRetailCost = (newValue?.expected_material_cost + newValue?.expected_total_service_cost) + (((newValue?.expected_material_cost)) * values?.sub_category?.markup / 100)
                            //   console.log("################Product totalRetailCost", totalRetailCost);
                            //   setFieldValue('retail_price', totalRetailCost.toFixed(2))
                            // } else {
                            //   setFieldValue('retail_price', '')
                            // }

                            // BACKUP: if (newValue?.expected_cost) {
                            // expected_cost can be 0 for material/install-only formulas; still populate formula_cost from markup fields
                            if (newValue?.expected_cost || newValue?.expected_material_cost_with_markup || newValue?.expected_service_cost_with_markup || newValue?.install_labour_cost_with_markup || newValue?.expected_cost_with_markup) {
                              // const totalRetailCost = inHouse === 6 ? ((newValue?.expected_cost|| 0) - (newValue?.install_labour_cost_with_markup || 0) )  : ((newValue?.expected_material_cost_with_markup || 0) + (newValue?.expected_service_cost_with_markup || 0) + (newValue?.install_labour_cost_with_markup || 0)) 
                              const totalRetailCost = inHouse === 6 ? (newValue?.expected_cost|| 0)  : ((newValue?.expected_material_cost_with_markup || 0) + (newValue?.expected_service_cost_with_markup || 0) + (newValue?.install_labour_cost_with_markup || 0)) 
                              console.log("################Product totalRetailCost", totalRetailCost);
                              setFieldValue('formula_cost', Number(totalRetailCost).toFixed(2))
                              
                              // Calculate expected_cost (without markup)
                              const expectedCost = newValue?.expected_cost || 0;
                              setFieldValue('expected_cost', expectedCost);
                              
                              // Calculate Product cost (Retail) - same logic as the disabled field
                              const productCostRetail = (fromSplitEstimate || inHouse == 6) 
                                ? totalRetailCost 
                                : ((newValue?.expected_material_cost_with_markup || 0) + (newValue?.expected_service_cost_with_markup || 0)); //  + (newValue?.expected_install_labor_cost_with_markup || 0)
                              
                              // Set Actual Retail Price from Product cost (Retail)
                              setFieldValue('retail_price', Number(productCostRetail.toFixed(2)));
                              
                              // Get install labor quantity from recipe services (service_id == 10)
                              if (newValue?.services && Array.isArray(newValue.services)) {
                                const installLaborService = newValue.services.find(service => service.service_id == 10);
                                if ((fromSplitEstimate || inHouse == 6) && installLaborService && installLaborService.quantity) {
                                  setFieldValue('install_labour_quantity', installLaborService.quantity);
                                  // Set Actual Install Price from Install Labor Cost
                                  const installLaborCost = newValue?.expected_install_labor_cost || 0;
                                  setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
                                } else if (!fromSplitEstimate && inHouse != 6) {
                                  // Set Actual Install Price from Install Labor Cost
                                  const installLaborCost = newValue?.install_labour_cost_with_markup || 0;
                                  setFieldValue('install_cost', Number(installLaborCost.toFixed(2)));
                                }
                              }
                              
                              // Set retail_price with split percentage calculation for fromSplitEstimate or inHouse == 6
                              if ((fromSplitEstimate || inHouse == 6) && splitPercentage) {
                                const splitAmount = parseFloat(totalRetailCost) * (splitPercentage / 100);
                                const finalRetailPrice = parseFloat(totalRetailCost) + splitAmount;
                                setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
                              }
                            } else {
                              setFieldValue('formula_cost', '')
                              setFieldValue('expected_cost', 0)
                              if (fromSplitEstimate) {
                                setFieldValue('retail_price', '')
                              }
                            }
                          } else {
                            setFieldValue('recipe', null);
                            setFieldValue('s_price', '');
                            setFieldValue('price', '');
                            setFieldValue('formula_cost', '')
                            setFieldValue('pf_retail_markup', '');
                            setFieldValue('markupPrice', '');
                            setFieldValue('expected_cost', 0);
                            if (fromSplitEstimate) {
                              setFieldValue('retail_price', '');
                            }
                          }
                        }}
                        
                        renderInput={(params) => (
                          <TextField {...params} required fullWidth
                            error={Boolean(touched.recipe && errors.recipe)}
                            helperText={touched.recipe && errors.recipe}
                            label='Select a product formula'
                          />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}
                      />
                      {(!(fromSplitEstimate || selectedTab === 'split_catalog' || inHouse == 6 || fromRecipeList) || inHouse == 7) ? (
                        <Button
                          variant="outlined"
                          startIcon={<Icon icon={values.recipe ? editFill : plusFill} />}
                          onClick={() => setOpenRecipeModal(true)}
                          sx={{ 
                            mt: 0.5,
                            whiteSpace: 'nowrap',
                            minWidth: 'auto'
                          }}
                        >
                          {values.recipe ? 'Edit Formula' : 'Add Formula'}
                        </Button>
                      ):''}
                      </Box>
                      {/* </div>
                      <div>
                        <InputLabel htmlFor="material-cost">Material Cost</InputLabel> */}
                      {/* <TextField fullWidth
                        // sx={{ width: 310 }}
                        id="material-cost"
                        // label='PFC/Jobcost'
                        label='Material Cost(Retail)'
                        type="text"

                        value={(typeof values?.s_price === 'number') ? values?.s_price.toFixed(2) : ''}
                        onChange={(event, newValue) => {
                          setFieldValue(s_price, newValue)
                        }}
                        disabled={true}
                        error={Boolean(touched.s_price && errors.s_price)}
                        helperText={touched.s_price && errors.s_price}
                      /> */}
                      {/* </div> */}
                    </Stack>}
                    {
                         inHouse == 6 || selectedTab == 'split_catalog' || fromSplitEstimate ? 
                         <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                         <Autocomplete
                           sx={{ width: '100%' }}
                           id="combo-box-demo-type-single"
                           options={filteredOtherFacilityTypes || []}
                           {...getFieldProps('facility_id')}
                           onChange={(event, newValue) => {
                             setFieldValue('facility_id', newValue);
                             
                             // Filter and set install labor cost when facility_id changes
                             if (newValue && (inHouse == 6 || fromSplitEstimate)) {
                               const filteredInstallLabour = otherInstallationSplitInstallLabour.filter(
                                 item => item.facility_id == newValue.id
                               );
                               
                               if (filteredInstallLabour.length > 0) {
                                 const installLaborCost = filteredInstallLabour[0].total_cost;
                                 setFieldValue('install_labour_cost_with_markup', installLaborCost);
                                 
                                 // Calculate install_cost based on quantity and labor cost
                                 const quantity = values.install_labour_quantity || 0;
                                 const totalInstallCost = installLaborCost * quantity;
                                 setFieldValue('install_cost', totalInstallCost);
                               }
                               
                               // Get split percentage from currentInstallationSplitManagementSettings for inHouse == 6 or split_catalog
                               if (inHouse == 6 || selectedTab == 'split_catalog') {
                                 const splitSettings = currentInstallationSplitManagementSettings.find(
                                   setting => setting.id == currentFacilityId
                                 );
                                 
                                 if (splitSettings) {
                                   const facilitySplitPercentage = splitSettings.split_percentage || 0;
                                   setSplitPercentage(facilitySplitPercentage);
                                   
                                   // Update retail price with split percentage if formula_cost exists
                                   if (values.formula_cost) {
                                     const splitAmount = parseFloat(values.formula_cost) * (facilitySplitPercentage / 100);
                                     const finalRetailPrice = parseFloat(values.formula_cost) + splitAmount;
                                     setFieldValue('retail_price', Number(finalRetailPrice.toFixed(2)));
                                   }
                                 }
                               }
                             } else if (!newValue && (inHouse == 6 || fromSplitEstimate)) {
                               // Reset to initial state when facility type is unselected
                               setFieldValue('install_labour_cost_with_markup', null);
                               setFieldValue('install_cost', '');
                               setFieldValue('install_labour_quantity', 0);
                               
                               // Reset split percentage for inHouse == 6 or split_catalog
                               if (inHouse == 6 || selectedTab == 'split_catalog') {
                                 setSplitPercentage(0);
                                 
                                 // Reset retail price if no facility is selected
                                 if (values.formula_cost) {
                                   setFieldValue('retail_price', values.formula_cost);
                                 }
                               }
                             }
                           }}
                           getOptionLabel={(option) => option?.label ?? ''}
                           isOptionEqualToValue={(option, value) => option?.id === value?.id}
                           renderInput={(params) => (
                             <TextField
                               required
                               {...params}
                               label="Choose Facility"
                               placeholder="Select facility"
                               error={Boolean(touched.facility_id && errors.facility_id)}
                               helperText={touched.facility_id && errors.facility_id}
                             />
                           )}
                         />
                       </Stack>
                         : ''
                       }
                    {(inHouse || isTrafficCatalog || selectedTab === 'split_catalog') &&<Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      {/* <TextField
                        fullWidth
                        required
                        // label='PFC+Labor markup'
                        // label='Service+Labor markup' previos
                        label='Service Cost(Retail)'
                        id="price"
                        type="text"
                        disabled
                        // {...getFieldProps('price')}
                        value={(typeof values?.markupPrice === 'number') ? values?.markupPrice.toFixed(2) : ''}

                        onChange={(event, newValue) => {
                          setFieldValue('markupPrice', newValue)
                          // setFieldValue('price',event.target.value)
                          // if(event?.target?.value && values?.category?.markup){
                          //   const WholesalePrice = Number(event?.target?.value)
                          //   const totalRetailCost = WholesalePrice + (WholesalePrice * values?.category?.markup / 100)
                          //   setFieldValue('retail_price',totalRetailCost)
                          // }else{
                          //   setFieldValue('retail_price','')
                          // }
                        }}
                        error={Boolean(touched.price && errors.price)}
                        helperText={touched.price && errors.price}
                      /> */}
                      {/* {inHouse !== 6 ? */}
                      <TextField
                        fullWidth
                        required
                        label= 'Product cost (Retail)'
                        id="product_cost_retail"
                        type="text"
                        disabled
                        value={(() => {
                          // For split formulas (fromSplitEstimate or inHouse == 6), use expected_cost
                          if (fromSplitEstimate || inHouse == 6) {
                            return values?.formula_cost ? Number(values.formula_cost).toFixed(2) : 0;
                          }
                          
                          // For other formulas, use the original calculation
                          const materialCost = typeof values?.s_price === 'number' ? values.s_price : 0;
                          const serviceCost = typeof values?.markupPrice === 'number' ? values.markupPrice : 0;
                          const totalCost = materialCost + serviceCost;
                          
                          return totalCost > 0 ? totalCost.toFixed(2) : 0;
                        })()}
                        error={Boolean(touched.product_cost_retail && errors.product_cost_retail)}
                        helperText={touched.product_cost_retail && errors.product_cost_retail}
                      />
                      {/* :''} */}

                      {(values?.recipe?.install_labour_cost_with_markup > 0 || values?.recipe?.expected_install_labor_cost > 0 ) && (
                        <TextField
                          fullWidth
                          label='Install Labor Cost'
                          id="install_labour_cost"
                          type="text"
                          disabled
                          value={ (fromSplitEstimate || inHouse == 6) ? values?.recipe?.expected_install_labor_cost?.toFixed(2) || 0 : values?.recipe?.install_labour_cost_with_markup?.toFixed(2) || 0}
                        />
                      )}

                    </Stack>}
                       {(inHouse == 6 || fromSplitEstimate) ? (
                         <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                           <TextField
                             fullWidth
                             label={`Install Cost (${values.facility_id?.label || 'facility'})`}
                             id="install_labour_cost"
                             type="number"
                             disabled
                             value={values.install_labour_cost_with_markup ? values.install_labour_cost_with_markup.toFixed(2) : 0}
                           />
                           <TextField
                             fullWidth
                             disabled={true}
                             label="Install Labor Quantity"
                             id="install_labour_quantity"
                             type="number"
                             inputProps={{ min: 0 }}
                             value={values.install_labour_quantity || 0}
                             onChange={(event) => {
                               const quantity = parseFloat(event.target.value) || 0;
                               setFieldValue('install_labour_quantity', quantity);
                               
                               // Update install_cost based on quantity and labor cost
                               if (values.install_labour_cost_with_markup) {
                                 const totalInstallCost = values.install_labour_cost_with_markup * quantity;
                                 setFieldValue('install_cost', totalInstallCost);
                               } else {
                                 // Reset install_cost if no labor cost is set
                                 setFieldValue('install_cost', '');
                               }
                             }}
                             onWheel={(e) => e.target.blur()}
                             onKeyPress={(event) => {
                               if (event.key === '-') {
                                 event.preventDefault();
                               }
                             }}
                           />
                         </Stack>
                       ):''}
                    {
                      !inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog' &&
                    
                     <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                       <TextField
                         fullWidth
                         label="Price"
                         type="number"
                         value={values?.sub_contract_price || 0}
                         onChange={(event, newValue) => {
                           setFieldValue('sub_contract_price', event.target.value)
                         }}
                         onWheel={(e)=>e.target.blur()}
                         onKeyPress={(event) => {
                           if (event.key === '0' && event.target.value === '') {
                             event.preventDefault();
                           }
                           if (event.key === '-') {
                             event.preventDefault();
                           }
                          
                         }}
                         error={Boolean(touched.sub_contract_price && errors.sub_contract_price)}
                         helperText={touched.sub_contract_price && errors.sub_contract_price}
                        />

                                <TextField
                                  fullWidth
                                  label="Markup (%)"
                                  value={values?.markup || 0}
                                  onChange={(event, newValue) => {
                                    let value = event.target.value
                                    let markUpData = parseFloat(value).toFixed(2)
                                    setFieldValue('markup', value)
                                  }}
                                  type="number"
                                  onWheel={(e)=>e.target.blur()}
                                  onKeyPress={(event) => {
                                 
                                    if (event.key === '-') {
                                      event.preventDefault();
                                    }
                                  }}
                                  error={Boolean(touched.markup && errors.markup)}
                                  helperText={touched.markup && errors.markup}
                                />


                     </Stack>
                    }
                    {
                      !inHouse && !isTrafficCatalog && selectedTab !== 'split_catalog' &&
                     <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                       <TextField
                         fullWidth
                         label="Retail Price"
                         type="number"
                         sx={{width: '50%'}}
                         disabled
                         value={(() => {
                           const price = Number(values?.sub_contract_price) || 0;
                           const markup = Number(values?.markup) || 0;
                           const retailPrice = price * (1 + markup / 100);
                           return retailPrice ? retailPrice.toFixed(2) : 0;
                         })()}
                         onWheel={(e)=>e.target.blur()}
                        />
                     </Stack>
                    }
                    {(inHouse || isTrafficCatalog || selectedTab === 'split_catalog')&&
                    <>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      {/* no neeed of wholesale 14-01-25 */}
                      {/* <TextField
                        fullWidth
                        required
                        label='Wholesale Price'
                        id="price"
                        type="text"
                        disabled
                        // {...getFieldProps('price')}
                        value={values.price}
                        onChange={(event, newValue) => {
                          setFieldValue('price', newValue)
                        }}
                        error={Boolean(touched.price && errors.price)}
                        helperText={touched.price && errors.price}
                      /> */}
                      {/*  */}
                          {/* // setFieldValue('price',event.target.value)
                          // if(event?.target?.value && values?.category?.markup){
                          //   const WholesalePrice = Number(event?.target?.value)
                          //   const totalRetailCost = WholesalePrice + (WholesalePrice * values?.category?.markup / 100)
                          //   setFieldValue('retail_price',totalRetailCost)
                          // }else{
                          //   setFieldValue('retail_price','')
                          // } */}
                     

                      <TextField
                        sx={{ width: inHouse == 6 ? '50%' : '100%' }}
                        required
                        label='Formula Cost'
                        id="formula_cost"
                        type="text"
                        disabled
                        value={values?.formula_cost || 0}
                        onChange={(event, newValue) => {
                          setFieldValue('formula_cost', newValue)
                        }}
                        // {...getFieldProps('retail_price')}
                        error={Boolean(touched.formula_cost && errors.formula_cost)}
                        helperText={touched.formula_cost && errors.formula_cost}
                      />
                      {
                        (inHouse == 6 || fromSplitEstimate) ?
                        <TextField
                           sx={{ width: '50%' }}
                           label="Outgoing Percentage %"
                           id="outgoing_percentage"
                           type="number"
                           disabled
                           value={splitPercentage ? splitPercentage : '0.00'}
                         />
                        :''
                      }
                      {/* <TextField
                        fullWidth
                        required
                        name="retail_price"
                        label='Retail Price'
                        id="retail_price"
                        type="number"
                        inputProps={{ min: 0 }}
                        // disabled
                        value={values?.retail_price}
                        // onChange={(event, newValue) => {
                        //   setFieldValue('retail_price', newValue)
                        // }}
                        onChange={handleChange} 
                        // {...getFieldProps('retail_price')}
                        error={Boolean(touched.retail_price && errors.retail_price)}
                        helperText={touched.retail_price && errors.retail_price}
                      /> */}
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <TextField
                        fullWidth
                        required
                        name="retail_price"
                        label='Actual Retail Price'
                        id="retail_price"
                        disabled={selectedTab === 'split_catalog' || fromSplitEstimate || inHouse == 6}
                        type="number"
                        inputProps={{ min: 0 }}
                        // disabled
                        value={values?.retail_price || 0}
                        // onChange={(event, newValue) => {
                        //   setFieldValue('retail_price', newValue)
                        // }}
                        onChange={handleChange} 
                        // {...getFieldProps('retail_price')}
                        error={Boolean(touched.retail_price && errors.retail_price)}
                        helperText={touched.retail_price && errors.retail_price}
                      />
                        <TextField
                        fullWidth
                        required
                        disabled={selectedTab === 'split_catalog' || fromSplitEstimate || inHouse == 6}
                        name="install_cost"
                        label='Actual Install Price'
                        id="install_cost"
                        type="number"
                        inputProps={{ min: 0 }}
                        // disabled
                        value={values?.install_cost || 0}
                        onChange={handleChange} 
                        error={Boolean(touched.install_cost && errors.install_cost)}
                        helperText={touched.install_cost && errors.install_cost}
                      />
                    </Stack>
                    </>
                    }
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                      <Autocomplete fullWidth
                        // sx={{ width: 400 }}
                        id="combo-box-demo"
                        options={category || []}
                        value={values.category}
                        onChange={(event, newvalue) => handleCategory(newvalue)}
                        // onChange={(event, newValue) =>setFieldValue('category', newValue)}
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.category && errors.category)}
                            helperText={touched.category && errors.category}
                            label="Select a category" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}

                      />
                      <Autocomplete fullWidth
                        // sx={{ width: 400 }}
                        id="combo-box-demo"
                        options={subCategory || []}
                        value={values.sub_category}
                        onChange={(event, newValue) => handleSubCategory(newValue)}
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.sub_category && errors.sub_category)}
                            helperText={touched.sub_category && errors.sub_category}
                            label="Select a Sub Category" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}
                      />
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                      {/* <Autocomplete
                        fullWidth
                        id="combo-box-demo"
                        options={UNITS}
                        value={values.unit}
                        onChange={(event, newValue) => {
                          setFieldValue('unit', newValue)
                          if (newValue && newValue?.id == 4) {
                            setFieldValue('unit_qty', '')
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.unit && errors.unit)}
                            helperText={touched.unit && errors.unit}
                            label="Select a unit" />
                        )}
                        getOptionLabel={(option) => option.name ? option.name : ''}
                      /> */}
                      {/* {((values?.unit) && (values?.unit?.id !== 4)) ?
                      <TextField
                        fullWidth
                        label={'Number of '+values?.unit?.name}
                        type="number"
                        onKeyPress={(event) => {
                          // console.log('errorFieldId------',errorFieldId)
                          if (event.key === '0' && event.target.value === '0' ) {
                            event.preventDefault();
                          }
                          if (event.key === '0' && event.target.value === '' ) {
                            event.preventDefault();
                          }
                          if (event.key === '-' ) {
                            event.preventDefault();
                          }
                          if (event.key === '.' ) {
                            event.preventDefault();
                          }
                        }}
                        {...getFieldProps('unit_qty')}                  
                        error={Boolean(touched.unit_qty && errors.unit_qty)}
                        helperText={touched.unit_qty && errors.unit_qty}
                      /> : null } */}
                      <Autocomplete
                        freeSolo
                        multiple
                        fullWidth
                        id="tags-outlined"
                        // options={tags}
                        options={[]}
                        value={tags || []}
                        onChange={(event, newValue) => setTags(newValue)}
                        inputValue={inputValue}
                        onInputChange={handleInputChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Tags"
                            onKeyDown={handleKeyDown}
                          />
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((tag, index) => (
                            <Chip
                              key={index}
                              label={tag}
                              onDelete={() => handleDelete(tag)}
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                      />
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                      <Autocomplete
                        fullWidth
                        // sx={{ width: 400 }}
                        id="combo-box-demo"
                        options={workflows}
                        value={values.workflows}
                        onChange={(event, newValue) => setFieldValue('workflows', newValue)}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        getOptionLabel={(option) => option?.name || ''}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.name}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} required
                            error={Boolean(touched.workflows && errors.workflows)}
                            helperText={touched.workflows && errors.workflows}
                            label="Select a Production Workflow" />
                        )}
                      />
                      {(!(fromSplitEstimate || selectedTab === 'split_catalog' || inHouse == 6 || fromRecipeList) || inHouse == 7) ? (
                        <Stack direction="row" spacing={1} sx={{ mt: 0.5 }} alignItems="center">
                          <Button
                            variant="outlined"
                            startIcon={<Icon icon={values.workflows ? editFill : plusFill} />}
                            onClick={() => setOpenWorkflowModal(true)}
                            sx={{
                              whiteSpace: 'nowrap',
                              minWidth: 'auto'
                            }}
                          >
                            {values.workflows ? 'Edit Workflow' : 'Add Workflow'}
                          </Button>
                          {/* {selectedProductForCatalog && (
                            <LoadingButton
                              variant="outlined"
                              color="primary"
                              loading={isCombiningWorkflow}
                              onClick={handleCombineWorkflowOnly}
                              sx={{
                                whiteSpace: 'nowrap',
                                minWidth: 'auto'
                              }}
                            >
                              Combine Workflow
                            </LoadingButton>
                          )} */}
                        </Stack>
                      ):''}

                      {/* {(inHouse != 1 && inHouse != 6) && (
                          <TextField
                            fullWidth
                            required
                            label="Stock"
                            {...getFieldProps('in_stock_no')}
                            onChange={(e) => {
                              const numericOnly = e.target.value.replace(/\D/g, '');
                              setFieldValue('in_stock_no', numericOnly);
                            }}
                            error={Boolean(touched.in_stock_no && errors.in_stock_no)}
                            helperText={touched.in_stock_no && errors.in_stock_no}
                          />
                      )} */}

                    </Stack>
                    {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                  <TextField
                    fullWidth
                    label="Project Type"
                    {...getFieldProps('Type')}
                    error={Boolean(touched.Type && errors.Type)}
                    helperText={touched.Type && errors.Type}
                  />
                  <TextField
                    fullWidth
                    label="URL"
                    {...getFieldProps('URL')}
                    error={Boolean(touched.URL && errors.URL)}
                    helperText={touched.URL && errors.URL}
                    InputProps={{
                        endAdornment: (
                          <Link href={getFieldProps('URL').value} target="_blank" rel="noopener noreferrer">
                            
                          </Link>
                        ),
                      }}
                  />
                  <TextField
                    select
                    fullWidth
                    label="Country"
                    placeholder="Country"
                    {...getFieldProps('country')}
                    SelectProps={{ native: true }}
                    error={Boolean(touched.country && errors.country)}
                    helperText={touched.country && errors.country}
                  >
                    <option value="" />
                    {countries.map((option) => (
                      <option key={option.code} value={option.label}>
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Stack> */}

                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                      <Autocomplete fullWidth
                        // sx={{ width: 400 }}
                        id="combo-box-demo"
                        options={avaTaxCategory || []}
                        value={avaTaxCategory.find((item) => item.taxCodeId == values.taxCodeId) || null}
                        onChange={(event, newvalue) =>{
                              if(newvalue){
                                setFieldValue('taxCodeId', newvalue.taxCodeId);
                                setFieldValue('taxCode', newvalue.taxCode);
                              }else{
                                setFieldValue('taxCodeId', null);
                                setFieldValue('taxCode', '');
                              }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} 
                            // error={Boolean(touched.category && errors.category)}
                            // helperText={touched.category && errors.category}
                            label="Select Avalara Tax Category" />
                        )}
                        getOptionLabel={(option) => option.description ? option.description : ''}

                      />
                     
                    </Stack>

                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} >
                        <TextField
                          sx={{ width: { xs: '100%', sm: ((inHouse === 1 || inHouse === true) && !isTrafficCatalog) ? '100%' : '50%' } }}
                          label="Lead Time (Days)"
                          type="number"
                          value={values?.lead_time || ''}
                          onChange={(event) => {
                            const value = event.target.value;
                            // Allow empty input or positive integers only
                            if (value === '' || (/^\d+$/.test(value) && Number(value) >= 0)) {
                              setFieldValue('lead_time', value);
                            }
                          }}
                          onWheel={(e) => e.target.blur()} // prevent accidental scroll changes
                          onKeyPress={(event) => {
                            // Prevent minus or leading zero
                            if (event.key === '-' || (event.key === '0' && event.target.value === '')) {
                              event.preventDefault();
                            }
                          }}
                          inputProps={{ min: 0, step: 1 }}
                          error={Boolean(touched.lead_time && errors.lead_time)}
                          helperText={touched.lead_time && errors.lead_time}
                        />
                        {!((inHouse === 1 || inHouse === true) && !isTrafficCatalog) && (
                          <TextField
                            sx={{ width: { xs: '100%', sm: '50%' } }}
                            label="BIN Location"
                            type="text"
                            value={values?.bin_location || ''}
                            onChange={(event) => {
                              setFieldValue('bin_location', event.target.value);
                            }}
                            error={Boolean(touched.bin_location && errors.bin_location)}
                            helperText={touched.bin_location && errors.bin_location}
                          />
                        )}
                    </Stack>


                  </Stack>
                </Card>}
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                    
                      {selectedProductForCatalog?.addExistingEstimateCatalog ? 
                      <Button variant="contained" onClick={()=>{onClose(values.newProductId,true)}}>
                        Add Catalog
                      </Button> :
                       <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                        Add Catalog
                      </LoadingButton>}
                      <Button variant="outlined" type="button" onClick={handleCancel} sx={{ marginLeft: '10px' }}>
                        Cancel
                      </Button>
                    </Box>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
}
      </Container>
      
      <Modal
        modalTitle={values.recipe ? "Edit Product Formula" : "Add Product Formula"}
        open={openRecipeModal}
        handleClose={() => setOpenRecipeModal(false)}
        width={1200}
      >
        <JobCost 
          fromSplitEstimate={fromSplitEstimate || false}
          formulaName={values.recipe?.name || null}
          onRecipeCreated={handleRecipeCreated}
          setRecipes={setRecipe}
          formulaTab={(() => {
            let tab = 'production';
            if (isTrafficCatalog) {
              tab = 'traffic';
            } else if (inHouse == 6 || selectedTab === 'split_catalog' || fromSplitEstimate) {
              tab = 'split';
            }
            return tab;
          })()}
          recipeId={values.recipe?.id || null}
          fromAddProductsEdit={true}
        />
      </Modal>

      <Modal
        modalTitle={values.workflows ? "Edit Workflow" : "Add Workflow"}
        open={openWorkflowModal}
        handleClose={() => setOpenWorkflowModal(false)}
        width={1200}
      >
        <AddNewProductionWorkFlow 
          fromProducts={true} 
          setOpenWorkflowModal={setOpenWorkflowModal} 
          selectedWorkflowId={values?.workflows?.id || null} 
          onWorkflowCreated={handleWorkflowCreated}
        />
      </Modal>
    </Page>
  );
}
